import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ErrorHandler } from '../../common/errorHandler';
import { AuthenticationService } from '../../services/authentication.service';
import { QuizRunService } from '../../services/quiz.run.service';
import { QuizRun } from '../../models/quiz.run.model';
import { AccessRight } from '../../enums/access.right.enum';

@Component({
    selector: 'quiz-run-list',
    templateUrl: './quiz-run-list.component.html',
    styleUrls: ['./quiz-run-list.component.css'],
    providers: [QuizRunService, ErrorHandler]
})
export class QuizRunListComponent implements OnInit {
    quizRuns: Array<QuizRun>;
    isDataAvailable = false;

    constructor(
        private router: Router,
        private errorHandler: ErrorHandler,
        private quizRunService: QuizRunService)
    {
        this.quizRuns = new Array<QuizRun>();
    }

    ngOnInit() {
        this.getAll();
    }

    getAll(): void {
        this.quizRunService.getQuizRuns()
            .then(quizRuns => {
                this.quizRuns = quizRuns;
                this.isDataAvailable = true;
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz-run-list/quiz-run-list.component.ts